import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { DEFAULT_LANGUAGE } from '../../custom.config';
import { LocalStorageService } from '../storage/local-storage.service';
import { LOCAL_STORAGE_KEYS } from '../storage/storage.constant';

export const languageInterceptor: HttpInterceptorFn = (req, next) => {
  // Skip if explicitly requested
  if (req.headers.has('skip-language-interceptor')) {
    const cloned = req.clone({
      headers: req.headers.delete('skip-language-interceptor'),
    });
    return next(cloned);
  }

  const localStorageService = inject(LocalStorageService);
  // Always send backend-expected language codes only.
  const selectedLanguage = localStorageService.getItem(LOCAL_STORAGE_KEYS.CURRENT_LANGUAGE)?.toUpperCase();
  const lang = selectedLanguage === 'BN' ? 'BN' : DEFAULT_LANGUAGE;

  const cloned = req.clone({
    setHeaders: {
      'Accept-Language': lang,
    },
  });

  return next(cloned);
};
